import React from 'react';
import AbstractWidget from './AbstractWidget';
import { Typography, CircularProgress } from 'material-ui';
import styles from './HotelBook.css';
import HotelCategoryRender from '../../components/Reservation/HotelCategoryRender';
import translate from 'react-i18next/dist/commonjs/translate';
import { getUserInformation } from '../../components/Login/loginService';
import { isValidImage } from '../../components/Utils/shared';
import logoSource from '../../assets/hotel.svg';
import DynIcon from '../../components/Utils/DynIcon';
import FacilitiesIcons from '../../components/Utils/FacilitiesIcons';
import { getCMSConfiguration } from '../cmsLib';
/**
 * HotelBook usually render this item:
 * 
 * {
 *   "id": "SA001352", 
 *   "fixedDate": "2019-08-01", 
 *   "numberOfNights": 2, 
 *   "amount": 142, 
 *   "amountText": "Precio por persona y noche"
 * }
 */
class HotelBook extends AbstractWidget {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            hotel: {
                name: 'Loading..',
                code: '',
                state: { name: '' },
                town: { name: '' },
                description: '',
                locationDescription: '',
                defaultImage: logoSource,
                category: null
            }
        };
        this.currentUser = getUserInformation();
    }

    async componentDidMount() {
        let code = this.props.widget.id;
        let rooturl = process.env.REACT_APP_API_URL;

        const userLang = this.currentUser && this.currentUser.user_detail ?
            this.currentUser.user_detail.language.toLowerCase() : process.env.REACT_APP_DEFAULT_LANGUAGE;

        let url = `${rooturl}masterdata/hotels?code=${code}&augment=true&language=${userLang}`;
        const response = await fetch(url);
        const json = await response.json();
        this.hotelCode = json[0].code;
        this.setState({ hotel: json[0] });
        this.validateImage();        

    }

    validateImage() {
        isValidImage(this.state.hotel.defaultImage).then(valid => {
            if (valid && this.state.hotel) {
                this.setState(prevState => ({ loading: false, hotel: { ...prevState.hotel, defaultImage: this.state.hotel.defaultImage } }));
            } else {
                this.setState(prevState => ({ loading: false, hotel: { ...prevState.hotel, defaultImage: logoSource } }));
            }
        });
    }

    render() {
        const { widget, t } = this.props;
        const { hotel } = this.state;
        let facilities = (hotel.facilities || []).slice(0, 11);
        const descriptionKey = `description_${this.props.lng}`;
        let title = hotel.name;
        let totalCharts = title.length;
        let stylesTitle = { fontSize: '1.3rem', position: 'relative' };
        let showIcons = true;

        // If the title has more than 50 characters
        if (totalCharts > 50) {
            stylesTitle = { ...stylesTitle, fontSize: '1.1rem' };
            showIcons = false;
            // If the title has more than 76 characters, split it.
            if (totalCharts > 76) {
                title = title.slice(0, 76) + '...';
            }

        } else if (totalCharts > 30 && totalCharts <= 50) {
            showIcons = false;
        }

        let subTitle = `${hotel.town.name} - ${hotel.state.name}`;
        return (widget ?
            <div className="cmsHotelBook">
                <div className="cmsHotelBookImage" style={{ height: '12rem', maxHeight: 'inherit', objectFit: 'cover' }}>
                    {this.state.loading ?
                        <CircularProgress className="cmsProgressBar" /> :
                        <img className="cmsHotelBookImage" src={this.state.hotel.defaultImage} alt='Some alternative text' />
                    }
                </div>
                <div className="cmsHotelBookText" style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                    <div className="cmsHotelBookTitle" style={{ width: '100%' }}>
                        <Typography className="cmsHotelBookMainTitle" style={stylesTitle} variant="title" title={hotel.name}>
                            {title}
                        </Typography>
                        <HotelCategoryRender category={hotel.category} />
                        <Typography style={{ fontWeight: 600, marginTop: '0px', color: '#878787' }}>{subTitle}</Typography>
                    </div>

                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                            <FacilitiesIcons facilities={facilities} />
                        </div>
                        <div style={{ height: '1.2rem', borderTop: '1px solid #EEE' }}></div>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>

                            {this.getAction(widget)}
                            {widget.amount && <Typography className='cmsHotelBookPrice'>{t('CMS.PRICE_FROM')} {widget.amount}</Typography>}
                        </div>
                        {/* <Typography variant="caption" className="cmsHotelBookLeyend">{this.getLabels(widget.labels, 'amount.text')}</Typography> */}
                    </div>
                </div>
            </div >
            : ''
        );
    }
}

export default translate('translations')(HotelBook);


// WEBPACK FOOTER //
// ./src/cms/widgets/HotelBook.js